import React, { useEffect, useCallback, useState} from 'react';
import {sleep} from 'utils/sleep.js';
import ethereum from "decentralized/ethereum.js";
import Colors from 'components/Colors.js';
import ipfs from 'decentralized/Ipfs.js';
import {connect} from 'react-redux';
import {PAD} from 'packs/pack-types.js';
import {getPacks} from 'packs/packs.js';

const colors = new Colors();

const PadPacks = ({pad, sequencerEngine, loadedPack}) => { 
    let [packs, setPacks] = useState([]);
    useEffect(() => {
        getPacks().then(async (packs) => {
            let packsWithType = await ethereum.xanadu.getPacksWithType(packs.map(x => x.packHash), PAD);

            console.log("packs with type=", packsWithType);
            let _packs = [];
            for (let pack of packs) {
                if (!packsWithType.includes(pack.packHash)) {
                    continue;
                }

                _packs.push(pack);

            }
            setPacks(_packs);
        });
    }, []);

    const loadAsPad = useCallback(async ({packHash}) => {
        let json = await ipfs.getJson(packHash);
        pad.subSequence.loadPackAsPads(json.pad, json.fx, pad, packHash);
    }, [pad]);
 
    return (
        <div className="pad-packs">
          <div className="packs-header">
            <img src="/zpad-icon.svg"/> Packs
          </div>
          <div className="pack-list">
        {packs.map(
            x => <div
                   onClick={() => loadAsPad(x)}
                   className={loadedPack === x.packHash ? "selected pad-pack" : "pad-pack"}>
                   <div
                     style={{backgroundColor: colors.getColorForHash(x.title)}}
                     className="pack-thumb"></div>
                   {x.title}</div>)}
          </div>
        </div>
    );
};

const mapStateToProps = (state, props) => {
  return {
      loadedPack: props.pad.packHash
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PadPacks);
